<script setup>
import { useBgBlurState, useScopedBgBlurState } from "../blurState";

const props = defineProps({
  scope: {
    type: String,
    required: false,
    default: undefined,
  },
});

let scope = props.scope;
if (scope === undefined) {
  // if url contains scope, use it
  const urlParams = new URLSearchParams(window.location.search);
  scope = urlParams.get("agentPreviewScope");
}

const bgBlurState = scope ? useScopedBgBlurState(scope) : useBgBlurState();
</script>

<template>
  <v-tab v-if="bgBlurState.backgroundActive" value="backgroundSettings">{{ $t("BackgroundSettings") }}</v-tab>
</template>
